import { useMemo } from "react";

const useCombineLoading = (listLoading: boolean[]) => {
  const loading = useMemo(() => {
    return listLoading.some((item) => item);
  }, [listLoading]);

  return loading;
};

export default useCombineLoading;
